import { IGraphDataPoint } from "./graphing.entities";


export function FindUniqueTimestamps(points: IGraphDataPoint[]): number[] {
    let uniqueTimestamps: number[] = [];

    for (let i = 0; i < points.length; ++i) {
        if (!uniqueTimestamps.includes(points[i].getTimestamp())) { uniqueTimestamps.push(points[i].getTimestamp()); }
    }

    //other approach is faster (measured using console.time, console.timeEnd)
    //let timestamps: number[] = Array.from(new Set(points.map((point: IGraphDataPoint) => point.Timestamp)));

    return uniqueTimestamps.sort();
}

export function CreateSeries_EverDay(points: IGraphDataPoint[], cummulative: boolean = true, timestamps: number[] = []): any[] {

    //console.log(points);

    if (timestamps.length == 0) timestamps = FindUniqueTimestamps(points);

    let seriesData: any[] = [];

    let minDate: Date = new Date(timestamps[0]);
    let maxDate: Date = new Date(timestamps[timestamps.length - 1]);
    let currentDate: Date = minDate;
    let currentTimestamp: number;
    let dayTotal: number = 0;
    while (currentDate <= maxDate) {
        //console.log(currentDate);
        currentTimestamp = currentDate.getTime();
        dayTotal = 0;
        for (let j = 0; j < points.length; ++j) {
            if (cummulative && points[j].getTimestamp() <= currentTimestamp) { dayTotal += points[j].getCount(); }
            else if (!cummulative && points[j].getTimestamp() == currentTimestamp) { dayTotal += points[j].getCount(); }
        }
        seriesData.push([currentTimestamp, dayTotal]);

        currentDate.setDate(currentDate.getDate() + 1);
    }

    //console.log(seriesData);

    return seriesData;
}

export function CreateSeries_ActualDays(points: IGraphDataPoint[], cummulative: boolean = true, timestamps: number[] = []): any[] {

    //console.log(points);

    if (timestamps.length == 0) timestamps = FindUniqueTimestamps(points);

    let seriesData: any[] = [];
    let dayTotal: number = 0;
    for (let i = 0; i < timestamps.length; i++) {
        dayTotal = 0;
        for (let j = 0; j < points.length; ++j) {
            if (cummulative && points[j].getTimestamp() <= timestamps[i]) { dayTotal += points[j].getCount(); }
            else if (!cummulative && points[j].getTimestamp() == timestamps[i]) { dayTotal += points[j].getCount(); }
        }
        seriesData.push([timestamps[i], dayTotal]);
    }

    //console.log(seriesData);

    return seriesData;
}
